export const getActiveTab = (tabId, validTabIds) =>
  validTabIds.includes(tabId) ? tabId : validTabIds[0];

export const getTabPath = (basePath, tabId) => `${basePath}/${tabId}`;

export const isValidTab = (tabId, validTabIds) =>
  validTabIds.includes(tabId);
